import { cn } from 'lib/utils';
import { Progress as ProgressPrimitive } from 'radix-ui';
import * as React from 'react';

function Progress({ className, value, max, ...props }: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  // Radix exposes `value` out of `max` (default 100) to assistive tech; the bar follows the same scale
  const percent = ((value || 0) / (max || 100)) * 100;
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', className)}
      value={value}
      max={max}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary h-full w-full flex-1 rounded-full transition-all"
        style={{ transform: `translateX(-${100 - percent}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
